var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showMainActions":false,"showSearch":false,"showFilter":false}},[_vm._v("العملاء")]),_c('main-table',{attrs:{"baseURL":_vm.VUE_APP_MARKETPLACE_LINK,"fields":_vm.fields,"list_url":"admin/customers"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }